export default __webpack_public_path__ + "static/media/redux-svg.80b2c6e2.png";